import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { Session } from '../models/session.model';

@Injectable({
    providedIn: 'root'
})

export class AuthService {

    private currentSessionSubject: BehaviorSubject<Session>;
    public currentSession: Observable<Session>;

    constructor(
        private http: HttpClient
    ) {
        this.currentSessionSubject = new BehaviorSubject<Session>(JSON.parse(localStorage.getItem('currentSession')));
        this.currentSession = this.currentSessionSubject.asObservable();
    }

    generateDynamoPortalToken() {
        return this.http.get(`${environment.server.api.auth}/api/token/dynamo/getportaldata`).pipe(
            map((response: any) => response.data)
        );
    }

    auth(hash, token): Observable<boolean> {
        if (hash) {
            return this.http.post(`${environment.server.api.auth}/api/token/legacy/decode/${hash}`, null)
                .pipe(
                    map((data: any) => {
                        if (data && data.jwt) {
                            const sessionData = {
                                jwt: data.jwt,
                                userId: data.legacy.userId,
                                username: data.legacy.username
                            } as Session;

                            this.persistData(sessionData);
                            return true;
                        } else {
                            this.deletePersistedData();
                            return false;
                        }
                    },
                        error => {
                            this.deletePersistedData();
                            return false;
                        })
                );
        } else {
            return this.http.get(`${environment.server.api.auth}/api/token/ValidateToken?token=${token}`)
                .pipe(
                    map((data: any) => {
                        if (data) {
                            const sessionData = {
                                jwt: token,
                                userId: data.userId,
                                username: data.username
                            } as Session;

                            localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
                            this.persistData(sessionData);
                            return true;
                        } else {
                            this.deletePersistedData();
                            return false;
                        }
                    },
                        error => {
                            this.deletePersistedData();
                            return false;
                        })
                );
        }

    }

    public get currentSessionValue(): Session {
        return this.currentSessionSubject.value;
    }

    persistData(sessionData: Session) {
        localStorage.setItem('currentSession', JSON.stringify(sessionData));
        this.currentSessionSubject.next(sessionData);
    }

    deletePersistedData() {
        localStorage.removeItem('currentSession');
        localStorage.removeItem('tk');
        this.currentSessionSubject.next(null);
    }

    generateSingleSignatureCreditAccess(cuit: string) {
        return this.http.get(`${environment.server.api.auth}/api/SolaFirma?cuit=${cuit}`);
    }

    generateRetirementInsuranceAccess(cuit: string) {
        return this.http.get(`${environment.server.api.auth}/api/Retiro?cuit=${cuit}`);
    }

    public getToken(): string {
        return localStorage.getItem('tk');
    }
}
